import Chart from 'react-apexcharts';
import React, { Component, Fragment } from 'react';
import { Card, CardContent, Tooltip, Grid, Switch } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import exportOptions from '../chartExportOptions';


const info = <HelpOutline style={{ fontSize: 15 }}/>;

const legend = { 
  itemMargin: {
    horizontal: 0,
    vertical: 0
  },
  formatter: function(seriesName, opts) {
    const maxLength = 20;
    if(seriesName && seriesName.length > maxLength)
      return seriesName.substring(0, maxLength) + "...";
    return seriesName;
  },
}

const formatPercentage = (val) => { 
  if(!val) return "0%";
  if(val <0.2) return (Math.round(val * 1000) / 10) + "%"; // Anything below 20% should have one decimal
  return (val * 100).toFixed(0) + "%"; 
};

const commonConfig = {
  chart: { animations: { enabled: false }, toolbar: { show: false }, ...exportOptions("Date", "Count") },
  dataLabels: { enabled: false },
  xaxis: { type: "category", labels: { show: true }, crosshairs: { width: 1 } },
  yaxis: { labels: { formatter: formatPercentage } },
  legend: { ...legend, position: "top", show: true },
  theme: { mode: 'light', palette: 'palette2', },
  markers: { size: 3, strokeColors: '#fff', strokeWidth: 1, shape: "circle", radius: 2, },
  plotOptions: {bar: {columnWidth:"95%"}},
  tooltip:{ 
    z: { title:"Meetings" }
  },     
};

class HistogramComponent extends Component {
  constructor(props) {
    super(props);
    const config = {
      ...commonConfig,
      xaxis: { ...commonConfig.xaxis, labels: { ...commonConfig.xaxis.labels } },
      yaxis: { ...commonConfig.yaxis, labels: { ...commonConfig.yaxis.labels } },
      legend: { ...commonConfig.legend },
      theme: { ...commonConfig.theme },
      plotOptions: { bar: { ...commonConfig.plotOptions.bar } },
      tooltip: { ...commonConfig.tooltip },
    };
    if(props.xformatter)
      config.xaxis.labels.formatter = props.xformatter;
    if(props.stepSize)
      config.xaxis.stepSize = props.stepSize;
    if(props.xmin)
      config.xaxis.min = props.xmin;

    // Calculate series data into percentages for better visualisation
    props.series.forEach(s => {
      if(this.props.max)
        s.data = s.data.filter(d => d.x <= this.props.max);
      if(this.props.min)
        s.data = s.data.filter(d => d.x >= this.props.min);
    })


    this.state = { toggle: false, config, series: props.series };
  }

  toggleChartType(e) { this.setState({ toggle:!this.state.toggle }); }

  render() {

    if (!this.props.series)
      return null;

    const series  = this.state.toggle ? this.state.series.map(s => ({name:s.name, data:s.data.map(d => ({x:d.x, y:d.change}))})) : this.state.series;
    return (
      <Fragment >
        <Card className="card-box mb-0 pb-0">
          <CardContent style={{width:"100%"}} className="card-box mb-0 pb-0">
            <Grid container spacing={0} className="card-box mb-0 pb-0">
              <Grid item xs={9}>
                <div className="d-flex align-items-start">
                  <Tooltip title={this.props.tooltip ? this.props.tooltip : "No tooltip available for " + this.props.title}>
                    <div className=" font-weight-bold font-size-m" >{this.props.title} {info}</div>
                  </Tooltip>
                </div>
              </Grid>
              <Grid item xs={3} style={{ display: "flex", justifyContent: "flex-end" }}>
                <div className="d-flex align-items-start">
                  <Tooltip title="Toggle between histogram and delta change per bucket.">
                    <Switch checked={this.state.toggle} onChange={this.toggleChartType.bind(this)}  />
                  </Tooltip>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Chart options={this.state.config} series={series} type="bar" height="250"/>
              </Grid>
            </Grid>

          </CardContent>
         </Card>
        </Fragment>
    ); // end of return

  } // end of render()

} // end of class

export default HistogramComponent
